/*
 * Venn Platform API 1.0.0 Operations for "optimization-v3"
 * Automatically generated file - do not modify!
 */

import type { MultiOptimizationConfiguration, MultiOptimizationResponse } from '../types';
import type { OperationResult } from '../../utils';
import { buildRequestInit, extractError } from '../../utils';

/** Run new optimization with new constraints configuration */
export async function runAdHocMultiOptimization(
  body?: Partial<MultiOptimizationConfiguration>,
  signal?: AbortSignal,
): Promise<OperationResult<MultiOptimizationResponse>> {
  const endpoint = '/api/optimization/v3';
  const requestInit = buildRequestInit({
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
    signal,
  });
  const response = await fetch(endpoint, requestInit);
  if (response.status >= 200 && response.status < 400) {
    const content: MultiOptimizationResponse = (await response.json()) as MultiOptimizationResponse;
    return {
      content,
      status: response.status,
      headers: {},
    };
  }
  throw await extractError(response);
}
